import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { fileQueryKeys } from "./fileQueryKeys";

const IGNORED_PAGE_SIZE = 10;

export function useDirectoryItemCount(
  directoryPath: string,
  datasetId: string,
  resourceOwnerId?: string,
  searchTerm?: string,
  extensions?: string[],
  showHiddenFiles: boolean = false,
): UseQueryResult<number, Error> {
  const { files: fileService } = useDomainServices();

  return useQuery({
    queryKey: fileQueryKeys.directoryItemCount({
      directoryPath,
      datasetId,
      searchTerm,
      extensions,
      showHiddenFiles,
    }),
    queryFn: async ({ signal }) => {
      let itemCount = -1;

      if (searchTerm) {
        itemCount = await fileService.getFileCountForDirectory({
          path: directoryPath,
          datasetId,
          fileNameSearchTerm: searchTerm,
          extensions,
          showHiddenFiles,
          pageSize: IGNORED_PAGE_SIZE,
          options: {
            abortSignal: signal,
            resourceOwnerId,
          },
        });
      } else {
        itemCount = await fileService.getItemCountForDirectory({
          directoryPath,
          datasetId,
          extensions,
          showHiddenFiles,
          pageSize: IGNORED_PAGE_SIZE,
          options: {
            abortSignal: signal,
            resourceOwnerId,
          },
        });
      }

      return itemCount;
    },
    placeholderData: (previousData) => previousData,
  });
}
